import Cookie from 'js-cookie'
import { FunnelId } from 'modules/funnels/types/funnel-interface'

export const getSelectedFunnelStepCookie = (funnelId: FunnelId) =>
  Cookie.get(`funnel_${funnelId}_selected_step`)

export const removeFunnelStepCookie = (funnelId: FunnelId) => {
  Cookie.remove(`funnel_${funnelId}_selected_step`)
}

export const setIsEmailStatusNotificationClosedCookie = () =>
  Cookie.set(`isEmailStatusNotificationClosed`, '1')

export const getIsEmailStatusNotificationClosedCookie = () =>
  Cookie.get('isEmailStatusNotificationClosed')
